import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, Col, Container, Row } from "reactstrap";
import { addToCartAction } from "store/actions/cartAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "assets/scss/custom.scss";
import MainNavigation from "./AddToCart/MainNavigation";
import ItemsDetail from "./AddToCart/ItemsDetail";
import ItemsAddOns from "./AddToCart/ItemsAddOns";
import HeroSection from "./AddToCart/HeroSection";
import SpecialInstructions from "./AddToCart/SpeicalInstructions";
import CartAction from "./AddToCart/CartAction";
import cartDarkImage from "assets/img/blackCart.png";
import { checkFinalPrice } from "./checkFinalPrice";
import OfferItemsList from "./AddToCart/OfferItemsList";

const AddToCart = ({ isOpen, toggler, showItem, type }) => {
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const [selectedItem, setSelectedItem] = useState({
    id: null,
    name: "",
    images: [],
    items: [],
    restaurantID: "",
    currency: "",
    size: "",
    addons: [],
    notes: "",
    type: "",
    quantity: 1,
    price: 0,
    totalPrice: 0,
  });
  const [isLoading, setLoader] = useState(false);
  const currency = restaurantsDetail?.currency || "$";
  const bgColor = restaurantsDetail?.adminColor;


  useEffect(() => {
    if (type === "item") {
      setSelectedItem((prev) => ({
        ...prev,
        id: showItem?.id,
        name: showItem?.name,
        images: Array.isArray(showItem?.images) ? [...showItem?.images] : [],
        restaurantID: showItem?.restaurantID,
        currency: currency,
        estimatedTime: showItem?.estimatedTime || "",
        size: showItem?.variants?.[0]?.size || null,
        price: parseFloat(showItem?.variants?.[0]?.price).toFixed(2) || 0,
        totalPrice: parseFloat(showItem?.variants?.[0]?.price).toFixed(2) || 0,
      }));
    } else if (type === "offer") {
      setSelectedItem((prev) => ({
        ...prev,
        id: showItem?.id,
        name: showItem?.title,
        images: showItem?.image || "",
        items: Array.isArray(showItem.items)
          ? [...showItem.items]
          : showItem.items
          ? [showItem.items]
          : [],
        restaurantID: showItem?.restaurantID,
        type: "offer",
        currency: currency,
        price: parseFloat(showItem?.price).toFixed(2) || 0,
        totalPrice: parseFloat(showItem?.price).toFixed(2) || 0,
      }));
    }
  }, [showItem]);

  const existingCartItem = cartItems?.find((item) => item?.id === showItem?.id);

  const addToCart = (e) => {
    e.preventDefault();

    const simulatedValue = checkFinalPrice({
      cartItems,
      restaurant: restaurantsDetail,
      itemPrice: selectedItem?.totalPrice,
    });

    if (simulatedValue > 10000) {
      toast.warning(
        "Not enough space in the cart. Try removing the items from cart or adjust the quantity. Max order limit is 10000"
      );
      return;
    }

    if (type === "item") {
      if (!selectedItem?.id || !selectedItem?.size || !selectedItem?.price) {
        toast.warning("Invalid item. Please try again.");
        return;
      }

      setLoader(true);
      try {
        const { items, type, ...rest } = selectedItem;

        const cartItem = {
          ...rest,
          totalPrice: parseFloat(selectedItem?.totalPrice).toFixed(2),
        };

        const onSuccess = () => {
          setSelectedItem((prev) => ({
            ...prev,
            addons: [],
            notes: "",
            quantity: 1,
            totalPrice: 0,
          }));
          toggler();
          toast.success("Item added in the cart");
        };

        dispatch(addToCartAction(cartItem, onSuccess));
      } catch (err) {
        console.error("Error while adding item to cart:", err);
        toast.error("Error while adding item to cart");
      } finally {
        setLoader(false);
      }
    } else {
      if (!selectedItem?.id || !selectedItem?.price) {
        toast.warning("Invalid offer. Please try again.");
        return;
      }

      const { addons, size, items, ...rest } = selectedItem;

      setLoader(true);
      try {
        const cartItem = {
          ...rest,
          cartItems: items,
          totalPrice: parseFloat(selectedItem?.totalPrice).toFixed(2),
        };

        const onSuccess = () => {
          setSelectedItem((prev) => ({
            ...prev,
            quantity: 1,
            notes: "",
          }));
          toggler();
          toast.success("Offer added in the cart");
        };

        dispatch(addToCartAction(cartItem, onSuccess));
      } catch (err) {
        console.error("Error while adding item to cart:", err);
        toast.error("Error while adding item to cart");
      } finally {
        setLoader(false);
      }
    }
  };
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggler} size="xl">
        <ModalHeader
          toggle={toggler}
          className="align-items-center border-bottom py-3"
        >
          Add to Cart
          <div
            style={{
              position: "relative",
              display: "inline-block",
              cursor: "pointer",
            }}
          >
            <img
              src={cartDarkImage}
              style={{ maxWidth: "40px", maxHeight: "40px" }}
              className="w-full mr-4"
              alt="cart dark logo"
            />
            {cartItems?.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "20px",
                  backgroundColor: "red",
                  borderRadius: "100%",
                  fontSize: "9px",
                  color: "white",
                  padding: "3px 3px",
                  minWidth: "15px",
                  textAlign: "center",
                }}
              >
                {cartItems?.length}
              </div>
            )}
          </div>
        </ModalHeader>

        <Container className="px-0">
           
          <MainNavigation title={selectedItem?.name} />

          <Row className="mx-0 px-1 justify-content-center">
            <Col lg={5} md={12} xs={12} className="">
              <HeroSection slideImages={selectedItem?.images} />
            </Col>

            <Col lg={6} md={12} xs={12} className="px-1 mx-0 my-0">
              {type === "item" ? (
                <>
                  <ItemsDetail
                    id={showItem?.id}
                    data={showItem?.variants}
                    currency={showItem?.currency}
                    existingCartItem={existingCartItem}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    bgColor={bgColor}
                  />
                  {Array.isArray(showItem?.addOns) &&
                    showItem?.addOns.length > 0 && (
                      <ItemsAddOns
                        addonLabels={showItem?.addOns}
                        selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem}
                        currency={currency}
                      />
                    )}
                </>
              ) : (
                <>
                  <OfferItemsList offer={showItem} />
                </>
              )}

              <SpecialInstructions
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                bgColor={bgColor}
                type={type}
              />
            </Col>

            <Row className="mt-0 w-100">
              <Col className="top_cards__textarea w-100">
                <CartAction
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  addToCart={addToCart}
                  isLoading={isLoading}
                  bgColor={bgColor}
                />
              </Col>
            </Row>
          </Row>
        </Container>
      </Modal>
    </>
  );
};

export default AddToCart;
